import React from "react";
import ThankYouSignUp from "../ThankYouSignUp/ThankYouSignUp";
import SuccessImage from "../../assets/success.png";

const ChoosePlanFirstModal = ({ isOpened, onClose, onContinue }) => (
  <ThankYouSignUp
    EmailCheckText="You don't have a plan, please choose one first."
    handleConfirm={onContinue}
    image={SuccessImage}
    isOpened={isOpened}
    onClose={onClose}
    title="Before you continue"
  />
);

export default ChoosePlanFirstModal;
